export const maximumMediaSize = 25;
